import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import {
	faCircleCheck as fasCircleCheck,
	faArrowRight as fasArrowRight,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, List } from "bm-ui-kit";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";

interface StepFields {}

interface Props extends AbstractStepProps {
	result: number;
}

export class Result extends AbstractStep<StepFields, Props> {
	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		return (
			<>
				<Card.Header className="card-header-success px-0 pb-0">
					<Card.Title className="h4 text-center text-gold">
						<FontAwesomeIcon icon={fasCircleCheck} className="fa-4x py-4" />
						<span className="info-header d-block p-3">
							Jó hírünk van, az eddig megadott adatok alapján céged hitelképesnek bizonyult!
						</span>
					</Card.Title>
				</Card.Header>
				<Card.Body>{this.renderResult()}</Card.Body>
				<Card.Footer className="text-center mt-4">
					<Button
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Kérem a részletes tájékoztatót!
					</Button>
				</Card.Footer>
			</>
		);
	}

	private renderResult(): ReactNode {
		return (
			<>
				<p className="mt-3">
					Az <strong>elérhető hitel részleteit</strong> e-mailben küldjük meg a számodra:
				</p>
				<List itemStyle="tick" variant="primary" className="mt-4">
					<List.Item>
						<strong>Milyen összegű</strong> hitelt kaphat a céged?
					</List.Item>
					<List.Item>
						Milyen <strong>futamidő</strong> mellett?
					</List.Item>
					<List.Item>Mi a különbség a bankok között?</List.Item>
					<List.Item>Hogyan kerüld el a buktatókat?</List.Item>
				</List>
			</>
		);
	}

	protected getComponentName(): string {
		return "Result";
	}
}
